import React from "react";
import { FileText, GraduationCap, Scale } from "lucide-react";

const FeatureCards = () => {
  const features = [
    {
      icon: FileText,
      title: "Transparent Labeling",
      description: "Every product includes full ingredient lists, suggested use, and clear warnings. No hidden formulas.",
      highlight: "Full Disclosure"
    },
    {
      icon: GraduationCap,
      title: "Plain-English Education",
      description: "Articles on peptide chemistry, evidence quality, and what the research actually shows — no medical claims.",
      highlight: "Learn More"
    },
    {
      icon: Scale,
      title: "Clear Consumer Policies",
      description: "Easy-to-find refund, shipping, and privacy policies. Know your rights before you buy.",
      highlight: "Consumer First"
    }
  ];

  return (
    <section className="py-24 bg-[#fffaf5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3a2a26] mb-4">
            Why Shop With Us
          </h2>
          <p className="text-[#7a6b62] max-w-2xl mx-auto">
            Built on transparency, education, and clear policies
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="relative bg-gradient-to-b from-[#fdf2f4] to-[#fffaf5] border border-[#f0d8d4] rounded-2xl p-8 hover:border-[#d4a5ad] transition-all group"
            >
              {/* Highlight Badge */}
              <div className="absolute -top-3 left-6">
                <span className="bg-[#d4a5ad] text-white text-xs font-bold px-3 py-1 rounded-full">
                  {feature.highlight}
                </span>
              </div>

              <div className="w-16 h-16 bg-[#fdf2f4] rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#f7e8e4] transition-colors">
                <feature.icon className="w-8 h-8 text-[#b89a6d]" />
              </div>
              
              <h3 className="text-xl font-bold text-[#3a2a26] mb-3">{feature.title}</h3>
              <p className="text-[#7a6b62] leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;
